import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea3b940e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "分类名称",
        name: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
            placeholder: "分类名称"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "remark",
        label: "分类备注",
        name: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.remark,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.remark) = $event)),
            placeholder: "分类备注"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "image",
        label: "分类图片",
        name: "image"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.image,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.image) = $event)),
            style: {"display":"none"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_form_item_rest, null, {
            default: _withCtx(() => [
              _createVNode(_component_UploadComponent, {
                "on-change": _ctx.onImageChange,
                "source-url": _ctx.formState.image
              }, null, 8, ["on-change", "source-url"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "pid",
        label: "父分类",
        name: "region"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tree_select, {
            value: _ctx.formState.pid,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.pid) = $event)),
            "show-search": "",
            style: {"width":"100%"},
            "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
            placeholder: "请选择",
            "allow-clear": "",
            "tree-default-expand-all": "",
            "tree-data": _ctx.list,
            "field-names": {
                    children: 'children',
                     label: 'name',
                    key: 'id',
                    value: 'id',
                   }
          }, null, 8, ["value", "tree-data"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "sn",
        label: "sn",
        name: "sn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.sn,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.sn) = $event)),
            placeholder: "sn"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "link",
        label: "外链",
        name: "link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.link,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.link) = $event)),
            placeholder: "外链"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "sort",
        label: "排序",
        name: "sort"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.sort,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.sort) = $event)),
            placeholder: "排序"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}